<router-outlet></router-outlet>
<ngx-spinner bdColor="rgba(51,51,51,0.6)" size="medium" type="ball-scale-multiple"></ngx-spinner>
<ngx-spinner name="bd-filter" bdColor="rgba(51,51,51,0.6)" size="medium" type="ball-scale-multiple"></ngx-spinner>
<ngx-spinner name="intervention-list" bdColor="rgba(51,51,51,0.6)" size="medium" type="ball-scale-multiple"></ngx-spinner>
